import { useState } from "react";

import { useQuery } from "@tanstack/react-query";
import HeroSection from "./components/HeroSection";
import FeaturedHotelsSection from "./components/FeaturedHotelsSection";
import FeaturesSection from "./components/FeaturesSection";
import FAQSection from "./components/FAQSection";
import SEOMetaTags from "../../components/SEO/SEOMetaTags";

const HomePage = () => {
  const { data: authUser } = useQuery({ queryKey: ["authUser"] });

  // Default search values
  const [searchParams, setSearchParams] = useState({
    serviceType: "Boarding",
    location: "Selangor",
    checkInDate: new Date(new Date().getTime() + 8 * 60 * 60 * 1000)
      .toISOString()
      .split("T")[0],
    checkOutDate: new Date(
      new Date().getTime() + 8 * 60 * 60 * 1000 + 24 * 60 * 60 * 1000
    )
      .toISOString()
      .split("T")[0],
    allowSharedRooms: false,
  });

  const handleSearchParamsChange = (newParams) => {
    setSearchParams(newParams);
  };

  return (
    <>
      <SEOMetaTags
        title="Stayfur | Instant Booking for Pet Hotels in Malaysia"
        description="Stayfur - Find verified pet hotels in Malaysia with instant online booking. All listings are SSM-registered and reviewed by real pet owners."
        canonicalUrl="https://www.stayfur.com/"
        ogImage="https://res.cloudinary.com/dqbqw0rny/image/upload/v1744479559/My%20Brand/Stayfur_logo_white"
      />

      <div className="min-h-screen bg-gray-100">
        {/* Hero Section */}
        <div className="relative w-full h-auto">
          <HeroSection
            searchParams={searchParams}
            onSearchParamsChange={handleSearchParamsChange}
            authUser={authUser}
          />
        </div>
        <FeaturedHotelsSection searchParams={searchParams} />
        <FeaturesSection />
        <FAQSection />
      </div>
    </>
  );
};

export default HomePage;